<template>
    <favorites-state-provider #default="{ favoritesCount }">
        <span v-if="!favoritesCount">У вас нет товаров в Избранном</span>
        <span v-else>{{ favoritesCount }}{{ getPluralString(favoritesCount)}} в Избранном</span>
    </favorites-state-provider>
</template>

<script>
import FavoritesStateProvider from './favorites-state-provider';

export default {
    name: 'favorites-status-profile',
    components: { FavoritesStateProvider },

    methods: {
        getPluralString(count) {
            if (count === 1) return ' товар';

            if (count < 5) return ' товара';

            return ' товаров';
        },
    },
};
</script>
